module.exports = __webpack_public_path__ + "img/icon-car-white.e7a6eca2.svg";